// @flow
const SeverityLevelsColors = {
  ERROR: '#D00000'
}

export function sendToSlack (data) {
  const body = {
    text: data.title,
    attachments: [
      {
        color: SeverityLevelsColors.ERROR,
        fields: [
          {
            value: JSON.stringify(data),
            short: false
          }
        ]
      }
    ]
  }

  fetch(`${process.env.REACT_APP_SLACK_WEBHOOK}`, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}



// WEBPACK FOOTER //
// ./src/services/slack.js